/* ============================================================
   HimalayaEcho — custom front-end enhancements (v1 · 2026-06-07)
   1) PDP desktop cursor-follow magnify (lightbox still works on click)
   2) Mobile sticky add-to-cart bar
   3) Collection filter color swatches (color-tag driven)
   All progressive & defensive — no-op if elements absent.
   ============================================================ */
(function () {
  'use strict';
  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  /* PDP cursor-follow magnify 已移除（用户要求取消 hover 跟随放大；点击放大/lightbox = Dawn 原生左上角放大按钮，保留） */

  /* ---------- 2) Mobile sticky add-to-cart ---------- */
  function initStickyATC() {
    if (window.matchMedia && window.matchMedia('(min-width: 750px)').matches) return;
    var form = document.querySelector('product-form form, .product-form');
    var realBtn = document.querySelector('.product-form__submit');
    // Grab the <h1> itself — Dawn's .product__title wrapper also holds a linked
    // <h2 class="h1"> copy, so matching the wrapper doubles the title text.
    var titleEl = document.querySelector('.product__title h1, h1.product__title') || document.querySelector('.product__title');
    if (!form || !realBtn || !titleEl) return;
    if (document.querySelector('.he-sticky-atc')) return;

    var priceEl = document.querySelector('.product__info-container .price__regular .price-item, .product__info-container .price .price-item--regular, .product__info-container .price');
    var title = (titleEl.textContent || '').trim();
    var priceHTML = priceEl ? priceEl.innerHTML : '';

    var bar = document.createElement('div');
    bar.className = 'he-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="he-sticky-atc__info">' +
        '<span class="he-sticky-atc__title"></span>' +
        '<span class="he-sticky-atc__price">' + priceHTML + '</span>' +
      '</div>' +
      '<button type="button" class="button button--primary he-sticky-atc__btn">Add to cart</button>';
    bar.querySelector('.he-sticky-atc__title').textContent = title;
    document.body.appendChild(bar);

    bar.querySelector('.he-sticky-atc__btn').addEventListener('click', function () {
      if (realBtn.disabled) return;
      realBtn.click();
    });

    // mirror disabled / label state from the real button
    var syncBtn = function () {
      var sb = bar.querySelector('.he-sticky-atc__btn');
      sb.disabled = realBtn.disabled;
      var txt = realBtn.querySelector('span') ? realBtn.querySelector('span').textContent.trim() : '';
      if (txt) sb.textContent = txt;
    };
    syncBtn();
    new MutationObserver(syncBtn).observe(realBtn, { attributes: true, childList: true, subtree: true });

    // show the bar once the real ATC scrolls out of view
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          bar.classList.toggle('is-visible', !en.isIntersecting);
          bar.setAttribute('aria-hidden', en.isIntersecting ? 'true' : 'false');
        });
      }, { rootMargin: '0px 0px -20% 0px' });
      io.observe(realBtn);
    }
  }

  /* ---------- 3) Collection filter color swatches ---------- */
  var COLORMAP = {
    red: '#9b1c31', garnet: '#8B1A1A', ruby: '#C41E3A', crimson: '#7b1e2b',
    purple: '#7e57c2', amethyst: '#7B4F9E', violet: '#7e57c2', lavender: '#b39ddb',
    blue: '#2c6e9b', sapphire: '#0F4C8A', aquamarine: '#7EC8C8', navy: '#27408b', teal: '#3aa6a0', turquoise: '#2E8B8B',
    green: '#2e8b57', emerald: '#2E7D4F', peridot: '#9DB73B', olive: '#7fae3a',
    pink: '#e58fa6', rose: '#e58fa6', opal: '#e58fa6',
    gold: '#b88a44', golden: '#b88a44', citrine: '#d8a531', topaz: '#D4A017', yellow: '#d8a531',
    pearl: '#F5F0E8', ivory: '#f4efe6', white: '#f4efe6', moonstone: '#e9eef2',
    clear: '#e9eef2', crystal: '#e9eef2', diamond: '#E8E8E8',
    black: '#20201f', silver: '#c8ccce', gray: '#9aa0a2', grey: '#9aa0a2',
    // elements
    fire: '#c0392b', water: '#2c6e9b', earth: '#6b8e3d', air: '#cfd8dd'
  };
  function swatchFor(label) {
    var t = label.toLowerCase();
    var keys = Object.keys(COLORMAP);
    for (var i = 0; i < keys.length; i++) {
      if (new RegExp('\\b' + keys[i] + '\\b').test(t)) return COLORMAP[keys[i]];
    }
    return null;
  }
  function initSwatches(root) {
    var labels = (root || document).querySelectorAll('.facet-checkbox__text-label');
    labels.forEach(function (el) {
      // 去掉日历排序用的 "NN " 前缀(birth_month 靠它让筛选按 1–12 月排;前缀仅用于排序、不展示)
      if (/^\d\d\s/.test(el.textContent)) el.textContent = el.textContent.replace(/^\d\d\s/, '');
      if (el.dataset.heSwatch) return;
      // 只给 Birthstone(含按月 birth_month)/ Element 筛选上色板;Style(motif)/Sentiment/Price 不上,
      // 避免 Style 里的 "Pearl & Moonstone" 撞上色名而冒出色点。
      var lbl = el.closest('label');
      var inp = lbl ? lbl.querySelector('input[name]') : null;
      var fn = inp ? (inp.getAttribute('name') || '') : '';
      if (fn.indexOf('birth') === -1 && fn.indexOf('element') === -1) return;
      var c = swatchFor(el.textContent || '');
      if (!c) return;
      el.dataset.heSwatch = '1';
      var dot = document.createElement('span');
      dot.className = 'he-swatch';
      dot.style.background = c;
      if (/#f4efe6|#f5f0e8|#e9eef2|#e8e8e8|#cfd8dd|#c8ccce/i.test(c)) dot.style.boxShadow = 'inset 0 0 0 1px rgba(32,32,31,.2)';
      el.parentNode.insertBefore(dot, el);
    });
  }

  /* ---------- 4) Shop by Style — inject category cover photos ---------- */
  /* Shop by Color mega-menu: 给每个月份/元素链接前加生辰石色点(仅 shop-by-color 下,不碰 Style/Sentiment) */
  function initMegaSwatches(root) {
    var links = (root || document).querySelectorAll('.mega-menu__content a.mega-menu__link[id^="HeaderMenu-shop-by-sign-stone-"]:not(.mega-menu__link--level-2)');
    links.forEach(function (a) {
      if (a.dataset.heMega) return;
      var c = swatchFor(a.textContent || '');
      if (!c) return;
      a.dataset.heMega = '1';
      var dot = document.createElement('span');
      dot.className = 'he-mdot';
      dot.style.background = c;
      a.insertBefore(dot, a.firstChild);
    });
  }
  function initGiftEditHeads(root) {
    var pairs = [
      ['HeaderMenu-the-gift-edit-birthday-gifts', 'By occasion'],
      ['HeaderMenu-the-gift-edit-for-mom', 'By recipient']
    ];
    pairs.forEach(function (p) {
      var a = (root || document).querySelector('a[id="' + p[0] + '"]');
      if (!a) return;
      var li = a.closest('li');
      if (!li || li.querySelector('a.he-ge-head')) return;
      var h = document.createElement('a');
      h.className = 'he-ge-head';
      h.href = '/pages/the-gift-edit';
      h.textContent = p[1];
      li.insertBefore(h, li.firstChild);
    });
  }
  function initCatCovers() {
    var sec = document.querySelector('[id$="__shop_by_style"]');
    if (!sec) return;
    var map = [
      { re: /animal/i, cls: 'he-cat-cover--animal' },
      { re: /floral|botanical/i, cls: 'he-cat-cover--floral' },
      { re: /statement/i, cls: 'he-cat-cover--statement' },
      { re: /pearl|moonstone|scarf/i, cls: 'he-cat-cover--pearl' }
    ];
    sec.querySelectorAll('.multicolumn-card').forEach(function (card) {
      if (card.querySelector('.he-cat-cover')) return;
      var link = card.querySelector('a');
      var hay = ((link ? link.getAttribute('href') || '' : '') + ' ' + (card.textContent || '')).toLowerCase();
      var m = map.find(function (x) { return x.re.test(hay); });
      if (!m) return;
      var d = document.createElement('div');
      d.className = 'he-cat-cover ' + m.cls;
      d.setAttribute('aria-hidden', 'true');
      card.insertBefore(d, card.firstChild);
    });
  }

  /* ---------- 5) Transparent overlay header on homepage ---------- */
  function initOverlayHeader() {
    if (!document.body.classList.contains('template-index')) return;
    var hw = document.querySelector('.header-wrapper');
    if (!hw) return;
    function setH() {
      var h = (hw.querySelector('.header') || hw).offsetHeight;
      if (h) document.body.style.setProperty('--he-header-h', h + 'px');
    }
    setH();
    window.addEventListener('resize', setH, { passive: true });
    function onScroll() { hw.classList.toggle('he-scrolled', window.scrollY > 60); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- 6) PDP trust badges + free-shipping note (audit #5/#6) ---------- */
  function initPdpBadges() {
    var anchor = document.querySelector('.product-form__buttons');
    if (!anchor) return;
    if (anchor.parentNode.querySelector('.he-pdp-badges')) return;
    var d = document.createElement('div');
    d.className = 'he-pdp-badges';
    d.innerHTML =
      '<div class="he-badge"><span>\u{1F512}</span> Secure checkout</div>' +
      '<div class="he-badge"><span>\u{1F504}</span> 30-day returns</div>' +
      '<div class="he-badge"><span>\u{1F4E6}</span> Free shipping on US orders over $59</div>';
    anchor.parentNode.insertBefore(d, anchor.nextSibling);
  }

  /* ---------- Gallery nav arrows (injected outside video stacking context) ----------
     The Dawn <video> element uses hardware compositing that overrides CSS z-index.
     Fix: inject brand-new <button> elements as siblings of slider-component inside
     media-gallery, positioned in the ~120px black margins beside the media content.
     These elements are outside the video's stacking context and render above it.
  ---------- */
  function initGalleryArrows() {
    var gallery = document.querySelector('media-gallery');
    var viewer  = gallery && gallery.querySelector('slider-component:not(.thumbnail-slider)');
    if (!viewer || !gallery) return;
    // Body-level guard survives media-gallery element replacement on custom-element upgrade
    if (document.body.dataset.heNavDone) return;
    document.body.dataset.heNavDone = '1';

    // Remove stale .he-nav buttons left by any previously-cached script version
    document.querySelectorAll('media-gallery > .he-nav').forEach(function (b) { b.remove(); });

    // Hide Dawn's built-in slider-buttons (replaced by our overlay)
    var dawnBtns = viewer.querySelector('.slider-buttons');
    if (dawnBtns) dawnBtns.style.display = 'none';

    // Delegate targets: Dawn's original prev/next buttons (still handle slide logic)
    var origPrev = viewer.querySelector('.slider-button--prev');
    var origNext = viewer.querySelector('.slider-button--next');
    // Explicitly hide Dawn's buttons even if they're outside .slider-buttons wrapper
    if (origPrev) origPrev.style.display = 'none';
    if (origNext) origNext.style.display = 'none';

    var SVG_PREV = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
    var SVG_NEXT = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';

    // Navigate by clicking the gallery thumbnails — the reliable method in this theme.
    // (Clicking Dawn's .slider-button--prev/next does NOT advance the main viewer here.)
    // Cyclic: wraps at both ends so both arrows always work, on image and video slides alike.
    function galGo(dir) {
      var thumbs = document.querySelectorAll('.thumbnail-list__item');
      if (thumbs.length < 2) return;
      var cur = 0;
      for (var i = 0; i < thumbs.length; i++) {
        var tb = thumbs[i].querySelector('button');
        if (tb && tb.getAttribute('aria-current') === 'true') { cur = i; break; }
      }
      var n = (cur + dir + thumbs.length) % thumbs.length;
      var nb = thumbs[n].querySelector('button');
      if (nb) nb.click();
    }

    function makeBtn(dir, svg) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'he-nav he-nav--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      b.innerHTML = svg;
      b.addEventListener('click', function () { galGo(dir === 'prev' ? -1 : 1); });
      return b;
    }

    var prevBtn = makeBtn('prev', SVG_PREV);
    var nextBtn = makeBtn('next', SVG_NEXT);

    // Insert as direct children of media-gallery, sibling of slider-component
    gallery.appendChild(prevBtn);
    gallery.appendChild(nextBtn);

    // Position both buttons vertically centered on the viewer, in the side margins
    function place() {
      var gR = gallery.getBoundingClientRect();
      var vR = viewer.getBoundingClientRect();
      if (!vR.width || !gR.width) return;

      var activeItem = viewer.querySelector('.product__media-item.is-active');
      var mc = activeItem && activeItem.querySelector('.product-media-container');
      var mcR = mc ? mc.getBoundingClientRect() : null;

      // Vertical center relative to viewer
      var midY = (vR.top - gR.top) + vR.height / 2;

      // Horizontal: place in the margin between viewer edge and media content
      // If no media-container found, default to 12px from viewer edges
      var leftX  = mcR ? Math.max(4, Math.round(mcR.left  - gR.left)  - 44 - 8) : Math.round(vR.left  - gR.left)  + 8;
      var rightX = mcR ? Math.max(4, Math.round(gR.right  - mcR.right) - 44 - 8) : Math.round(gR.right - vR.right) + 8;

      // Style both buttons
      [prevBtn, nextBtn].forEach(function (b) {
        b.style.position  = 'absolute';
        b.style.top       = midY + 'px';
        b.style.transform = 'translateY(-50%)';
        b.style.zIndex    = '9999';
      });
      prevBtn.style.left  = leftX  + 'px';
      nextBtn.style.right = rightX + 'px';
    }

    setTimeout(place, 120);

    var rsTimer;
    window.addEventListener('resize', function () { clearTimeout(rsTimer); rsTimer = setTimeout(place, 150); });

    // Watch for active slide change → re-measure media content size
    var moSlide = new MutationObserver(function () { setTimeout(place, 60); });
    viewer.querySelectorAll('.product__media-item').forEach(function (li) {
      moSlide.observe(li, { attributes: true, attributeFilter: ['class'] });
    });

    // Force software compositing on all existing videos immediately (prevents macOS Chrome
    // VideoToolbox GPU overlay from obscuring our nav buttons even if video auto-played)
    viewer.querySelectorAll('video').forEach(function (v) { v.style.filter = 'brightness(1)'; });
    // Also handle any future video elements or re-plays
    viewer.addEventListener('play', function (e) {
      if (e.target && e.target.tagName === 'VIDEO') {
        e.target.style.filter = 'brightness(1)';
      }
    }, true);
  }

  ready(function () {
    initStickyATC();
    initSwatches(document);
    initMegaSwatches(document);
    initGiftEditHeads(document);
    initCatCovers();
    initOverlayHeader();
    initGalleryArrows();
  });
  document.addEventListener('shopify:section:load', function () { initCatCovers(); initOverlayHeader(); initMegaSwatches(document); initGiftEditHeads(document); });
  // re-run swatches after Dawn re-renders facets (filter/sort updates the section)
  document.addEventListener('shopify:section:load', function () { initSwatches(document); });
  document.addEventListener('facet:update', function () { initSwatches(document); });
  // Dawn replaces the product grid + facets on filter change; observe for new labels
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () { initSwatches(document); });
    var target = document.getElementById('ProductGridContainer') || document.querySelector('.facets-container');
    if (target) mo.observe(target, { childList: true, subtree: true });
  }
})();

/* ── Veyamoon: rewrite UpPromote customer-referral invite links from the store's
   permanent .myshopify.com domain to the primary domain veyamoon.com. Tracking is
   unaffected — it rides on the ?sca_ref= param, and veyamoon.com is the real
   storefront (the .myshopify.com URL 301-redirects to it anyway). Purely cosmetic. */
(function () {
  var OLD = 'himalayaecho.myshopify.com';
  var NEW = 'veyamoon.com';
  function swap(s) { return (s && s.indexOf(OLD) > -1) ? s.split(OLD).join(NEW) : s; }
  function fixReferralDomain(root) {
    if (!root || !root.querySelectorAll) return;
    var inputs = root.querySelectorAll('input, textarea');
    for (var i = 0; i < inputs.length; i++) {
      var v = inputs[i].value;
      if (v && v.indexOf('sca_ref') > -1 && v.indexOf(OLD) > -1) inputs[i].value = swap(v);
    }
    var links = root.querySelectorAll('a[href*="sca_ref"], a[href*="' + OLD + '"]');
    for (var j = 0; j < links.length; j++) {
      var h = links[j].getAttribute('href');
      if (h && h.indexOf(OLD) > -1) links[j].setAttribute('href', swap(h));
    }
  }
  function runAll() { fixReferralDomain(document); }
  if (document.readyState !== 'loading') runAll();
  document.addEventListener('DOMContentLoaded', runAll);
  if ('MutationObserver' in window) {
    var obs = new MutationObserver(runAll);
    var start = function () { obs.observe(document.body, { childList: true, subtree: true }); };
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  }
  /* 点击可能打开 UpPromote 转介绍弹窗 → 点后跑一次 + 4s 内有限轮询兜底
     (UpPromote 异步 set input.value 不触发 MutationObserver);
     取代原来全站永久 setInterval(1200),无弹窗的页面不再空转 */
  document.addEventListener('click', function () {
    runAll();
    var n = 0, iv = setInterval(function () { runAll(); if (++n >= 8) clearInterval(iv); }, 500);
  }, true);
})();

/* ── Veyamoon: 推荐折扣自动套用兜底 (referral auto-apply hardener, 2026-07-24) ──
   问题：朋友走推荐链接进来，UpPromote 的隐藏 iframe 自动套码不稳，常常到结算页
   10% 还没自动应用，买家得自己发现并手动填（用户实测确认）。
   解法：只要检测到「推荐落地」（URL 带 sca_ref，或已种 sca_ref cookie），就用
   Shopify 官方的 /discount/{code} 直达端点把码套上——这是原生、能稳稳持久到结算页
   的方式。幂等；每会话只跑一次；**只对被推荐的人生效**（gated on sca_ref），绝不给
   非推荐访客漏 10%，也完全不碰归因（归因始终靠 UpPromote 的 sca_ref cookie）。
   券本身有 One-use-per-customer 兜底，重复套也不会叠加。
   🔑 CODE = 当前唯一的顾客推荐码；若日后在 UpPromote 改了码，这一行要同步改。 */
(function () {
  if (window.top !== window.self) return;   // 别在我们自己开的隐藏 iframe 里递归
  var CODE = 'VEYA-REF-A7K2QM9X';
  function referred() {
    try {
      if (new URLSearchParams(location.search).get('sca_ref')) return true;
      return /(^|;\s*)sca_ref=/.test(document.cookie);
    } catch (e) { return false; }
  }
  try { if (sessionStorage.getItem('vm_ref_code_applied') === '1') return; } catch (e) {}
  if (!referred()) return;
  try { sessionStorage.setItem('vm_ref_code_applied', '1'); } catch (e) {}
  function apply() {
    var f = document.createElement('iframe');
    f.style.display = 'none';
    f.setAttribute('aria-hidden', 'true');
    f.tabIndex = -1;
    f.src = '/discount/' + encodeURIComponent(CODE) + '?redirect=/cart';
    (document.body || document.documentElement).appendChild(f);
    setTimeout(function () { if (f && f.parentNode) f.parentNode.removeChild(f); }, 8000);
  }
  if (document.body) apply();
  else document.addEventListener('DOMContentLoaded', apply);
})();

/* ---- 聊天入口：即时占位药丸（2026-07-22 v4）----
   作用：Inbox 的 bundle 冷启动要 ~10s，这期间右下角是空的。先画一个同样式的
   药丸占位，等真的 <shopify-chat> 注册好再把占位撤掉，角落永远不空。

   🔴 2026-07-22 移除了 v3 的 "invisible warm-open"（用户报「首次访问聊天默认是展开的」）
   原实现：首次访问时用代码点开聊天面板预热 bundle，等 4500ms 后再去 shadow DOM 里
   找 button[aria-label="Close chat"] 关掉，然后恢复 visibility。
   为什么必然出事：
     · 它自己的注释就写着冷启动要 ~10s，却只等 4500ms 就去按关闭 —— 网速慢时面板还没
       渲染完，deepQuery 找不到关闭按钮，关闭失败；
     · 失败后 finish() 依然执行 host.style.visibility = ''，于是把一个**已经展开的**
       面板直接亮给访客看。
   结论：拿"少数会点聊天的人快几秒"去赌"每个新访客一进站就被弹开聊天面板"，不划算。
   如果以后还想做预热，必须满足：确认面板真的关上了才允许恢复 visibility；关不上就
   保持隐藏并退回占位药丸，绝不能把开着的面板暴露出去。 */
(function () {
  if (window.__heChatPh) return; window.__heChatPh = 1;
  var ph = null, gone = false;
  function kill() {
    if (gone) return; gone = true;
    if (!ph) return;
    ph.classList.add('he-chat-ph-hide');
    setTimeout(function () { if (ph && ph.parentNode) ph.parentNode.removeChild(ph); }, 450);
  }
  function mount() {
    if (document.getElementById('he-chat-placeholder') || document.querySelector('shopify-chat')) return;
    ph = document.createElement('button');
    ph.id = 'he-chat-placeholder';
    ph.type = 'button';
    ph.setAttribute('aria-label', 'Chat');
    ph.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8a2.5 2.5 0 0 1-2.5 2.5H13l-4.2 3.4a.75.75 0 0 1-1.2-.6V16H6.5A2.5 2.5 0 0 1 4 13.5v-8Z" fill="currentColor"/></svg><span>Chat</span>';
    ph.addEventListener('click', function () {
      var s = ph.querySelector('span');
      if (s) s.textContent = 'One moment...';
    });
    document.body.appendChild(ph);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else { mount(); }
  /* 真的聊天按钮一出现就撤掉占位——全程不点它、不开面板 */
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('shopify-chat').then(function () { setTimeout(kill, 600); });
  }
  var t = setInterval(function () {
    if (document.querySelector('shopify-chat')) { clearInterval(t); setTimeout(kill, 600); }
  }, 600);
  setTimeout(function () { clearInterval(t); kill(); }, 30000);
})();
